import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {TFFFanService} from "@biletix/features/account/components/account-page/tff/fan/services/tff-fan-service";
import {RouterService} from "@biletix/core/services/router.service";

@Injectable()
export class FanRegisterResolver implements Resolve<boolean> {

  constructor(private fanService:TFFFanService,
              private routerService: RouterService
  ) {
  }


  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | boolean {
    console.log('fan register resolver called');
    this.fanService.getMYSAccountsByLoggedInCustomerId(false).subscribe(response=> {
      console.log('fan register resolver response: ', response);
      if (response) {
        console.log('fan register resolver true');
        this.routerService.navigateToFanInfoPage();
        return false;
      } else {
        console.log('fan register resolver false')
        return true;
      }
    });
    return true;
  }


}
